import { stylesheet } from "typestyle";
import { CardReaderIcon } from "./CardReaderIcon.js";
import * as React from "react";
import { classNames } from "./utils.js";
import { layout } from "./layout.js";
import { theme } from "./theme.js";
export function CardReader({ message, className }) {
    return (React.createElement("div", { className: classNames(layout.horizontal, className) },
        React.createElement(CardReaderIcon, { className: styles.cardReaderIcon }),
        React.createElement("div", { className: classNames(layout.fill, theme.lessContrast, styles.terminalDisplay) }, message && message.map((line, index) => (React.createElement("div", { key: index }, line))))));
}
const styles = stylesheet({
    cardReaderIcon: {
        display: "block",
        height: "6em",
        width: "auto",
        flex: "0 0 auto"
    },
    terminalDisplay: {
        border: "0.25em solid var(--color-choice)",
        fontSize: "1.5em",
        padding: "0.5em 1em",
    },
});
//# sourceMappingURL=CardReader.js.map